import React from 'react';
import { MdOutlineCancel } from 'react-icons/md';
import TabLikeComponent from '../../components/Asignacion/TabLikeComponent';

const ConsultaMaquinas = () => {

    const handleSubmit = async (e) =>{
        e.preventDefault();
    };

  return (
    <div className="m-2 md:m-10 mt-16 p-2 md:p-4 bg-gray-100 rounded-3xl">


            <div className="container mx-auto p-2 md:p-2">
                <h1 className="text-2xl font-semibold mb-6">Consulta Maquinas</h1>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
                    <div className="md:col-span-2 bg-white p-6 rounded-lg shadow-lg">
                      <div className="grid grid-cols-1 md:grid-cols-3 gap-4" >
                            <div className="flex flex-col ">
                                <label className="text-xs font-semibold mb-1">Codigo</label>
                                <input
                                    type="text"
                                    className="border border-gray-300 p-2 rounded"
                                    value={""}
                                    onChange={(e) => (e.target.value)}
                                />
                            </div>
                            <div className="col-span-2">
                            <div className="flex flex-col ">
                                <label className="text-xs font-semibold mb-1">Descripción</label>
                                <input
                                    type="text"
                                    className="border border-gray-300 p-2 rounded"
                                    value={""}
                                    onChange={(e) => (e.target.value)}
                                />
                            </div>
                            </div>
                            <div className="flex flex-col">
                                <p className="text-xs text-gray-600"> Estado </p>
                                <select className="text-sm border border-gray-300 p-2 rounded" name="estado" value= {""} required onChange={()=>("")}>
                                    <option value="ACTIVO">Activo</option>
                                    <option value="INACTIVO">Inactivo</option>
                                    <option value="ELIMINADO">Eliminado</option>
                                </select>
                            </div>
                       </div>
  
                       
                    </div>
                    <div className="bg-white p-6 rounded-lg shadow-lg">
                        <button
                            onClick={handleSubmit}
                            className="bg-blue-600 text-white py-2 px-4 rounded mt-4"
                        >
                        Consultar
                        </button>
                    </div>
                </div>
            </div>


    <TabLikeComponent />


    </div>

  )
}

export default ConsultaMaquinas